import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';

const Navbar = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.nav-dropdown')) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = (dropdownId) => {
    setActiveDropdown(activeDropdown === dropdownId ? null : dropdownId);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
    setActiveDropdown(null);
  };

  const navItems = [
    { name: 'Home', href: '/', type: 'link' },
    { name: 'Services', href: '/services', type: 'link' },
    {
      name: 'Media Planning',
      type: 'dropdown',
      id: 'media-dropdown',
      items: [
        { name: 'Digital', href: '/digital-marketing' },
        { name: 'Print', href: '/print' },
        { name: 'Television', href: '/television' },
        { name: 'Theatre', href: '/theatre' }
      ]
    },
    {
      name: 'Our Works',
      type: 'dropdown',
      id: 'works-dropdown',
      items: [
        { name: 'Portfolio', href: '/portfolio' },
        { name: 'Industries', href: '/industries' }
      ]
    },
    {
      name: 'Connect',
      type: 'dropdown',
      id: 'connect-dropdown',
      items: [
        { name: 'About Us', href: '/about' },
        { name: 'Reach Us', href: '/contact' }
      ]
    }
  ];

  return (
    <nav className="working-navbar">
      <div className="nav-wrapper">
        {/* Logo */}
        <div className="nav-brand">
          <Link to="/" onClick={handleNavClick}>
            <img src="/assets/logos/arklogo.png" alt="ARK logo"/>
          </Link>
        </div>
        
        {/* Navigation Menu */}
        <div className={`nav-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          {navItems.map((item, index) => {
            if (item.type === 'link') {
              return (
                <Link
                  key={index}
                  to={item.href}
                  className={`nav-item ${location.pathname === item.href ? 'active' : ''}`}
                  onClick={handleNavClick}
                >
                  {item.name}
                </Link>
              );
            } else {
              return (
                <div key={index} className="nav-dropdown">
                  <button
                    className={`nav-item dropdown-trigger ${activeDropdown === item.id ? 'active' : ''}`}
                    onClick={() => toggleDropdown(item.id)}
                  >
                    {item.name} <span className="arrow">▼</span>
                  </button>
                  <div
                    id={item.id}
                    className={`dropdown-menu ${activeDropdown === item.id ? 'show' : ''}`}
                  >
                    {item.items.map((dropdownItem, idx) => (
                      <Link
                        key={idx}
                        to={dropdownItem.href}
                        className="dropdown-item"
                        onClick={handleNavClick}
                      >
                        {dropdownItem.name}
                      </Link>
                    ))}
                  </div>
                </div>
              );
            }
          })}
        </div>
        
        {/* Mobile Toggle */}
        <div className="mobile-toggle" onClick={toggleMobileMenu}>
          <span className={isMobileMenuOpen ? 'active' : ''}></span>
          <span className={isMobileMenuOpen ? 'active' : ''}></span>
          <span className={isMobileMenuOpen ? 'active' : ''}></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
